import type { FeedbackMessages } from './en';

const bg: FeedbackMessages = {
  qualified: {
    title: 'Благодарим Ви, че попълнихте това проучване!',
    text: 'Можете спокойно да затворите прозореца на браузъра.\n\nНадяваме се да Ви видим отново скоро.',
  },
  quotaFull: {
    title: 'Това проучване е затворено',
    text: 'Благодарим Ви за интереса към нашето проучване.\n\nЗа съжаление вече получихме всички отговори, от които се нуждаем.\n\nНадяваме се да Ви видим в едно от бъдещите ни проучвания!',
  },
  terminated: {
    title: 'Благодарим Ви, че споделихте своето мнение!',
    text: 'Надяваме се да Ви видим скоро в бъдещите ни проучвания. Дотогава Ви желаем прекрасен ден.\n\nМоля, затворете прозореца на браузъра.',
  },
  mismatch: {
    title: 'Благодарим Ви за интереса',
    text: 'За съжаление не спадате към целевата група за това конкретно проучване.\n\nМожете да затворите тази страница.',
  },
  error: {
    title: 'Не можем да обработим Вашата заявка',
    linkProblemDetailed:
      'Връзката, която сте последвали, има проблем. Моля, проверете дали връзката в адресната лента съответства на тази, която Ви е предоставена, и опитайте отново.',
    linkProblemGeneric:
      'Връзката, която сте последвали, има проблем. Моля, опитайте отново.',
    contactPerson:
      'Ако проблемът продължава, моля, уведомете лицето, от което сте получили връзката, за този проблем.',
  },
};

export default bg;
